import PropTypes from 'prop-types';
import React from 'react';

import { getImageUrl } from '../../../../../helpers';
import BackgroundImage from '../../BackgroundImage';
import styles from './circle.scss';

const propTypes = {
  image_id: PropTypes.string,
  size: PropTypes.number,
};

const RewardCircle = ({
  image_id,
  size = 24,
}) => (
  <div
    className={styles.container}
    style={{ width: `${size}px`, height: `${size}px` }}
  >
    <div
      className={styles.circle}
    >
      { image_id
        && (
        <BackgroundImage
          className={styles.icon}
          src={getImageUrl(image_id)}
          // Calculation to find the largest square we can draw inside a circle
          // of the size given (default = 72). Make it a little bit smaller (82%).
          style={{ backgroundSize: `${0.82 * Math.sqrt((size ** 2) / 2)}px ${0.82 * Math.sqrt((size ** 2) / 2)}px` }}
        />
        )}
    </div>
  </div>
);

RewardCircle.propTypes = propTypes;
export default RewardCircle;
